import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 375 200",
  preserveAspectRatio: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 -6H375V200C375 200 264.276 164.112 187.5 164.212C111.098 164.312 0 200 0 200V-6Z",
      fill: "#FEDDC7"
    }, null, -1)
  ])))
}
export default { render: render }